<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="zonaContenido">
    <!--El texto vive dentro de una tarjeta tipo "preview" (misma estética del informe)-->
    <div class="zonaPreview">
      <div class="metodologiaCard w3-white w3-scroll">
        @for (item of texto; track $index) {
          @if (item.type === 'header') {
            <div class="metHeader">{{ item.text }}</div>
          } @else {
            <div class="metText">{{ item.text }}</div>
          }
        }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>
